import { Suspense, lazy } from 'react'
import { ReactPlayerProps } from 'react-player'
import BaseReactPlayer from 'react-player/base'
import { Image, ImageProps } from '..'

export interface Props extends Omit<ReactPlayerProps, 'light' | 'url'> {
  cover?: string
  coverProps?: Omit<ImageProps, 'src'>
}

export type VideoPlayerClass = BaseReactPlayer<ReactPlayerProps>

const ReactPlayer = lazy(() => import('react-player'))

export default function VideoPlayer({ cover, coverProps, src, ...rest }: Props) {
  return (
    <Suspense>
      <ReactPlayer
        url={src}
        light={
          cover ? (
            <Image draggable={false} objectFit="contain" src={cover} {...coverProps} />
          ) : undefined
        }
        {...rest}
      />
    </Suspense>
  )
}
